const plugin = require('tailwindcss/plugin');
const lineClamp = plugin(function (_ref) {
  let {
    addUtilities,
    theme,
    variants,
    e
  } = _ref;
  const values = theme('lineClamp');
  addUtilities([Object.entries(values).map(_ref2 => {
    let [key, value] = _ref2;
    return {
      [`.${e(`line-clamp-${key}`)}`]: {
        overflow: 'hidden',
        display: '-webkit-box',
        '-webkit-box-orient': 'vertical',
        '-webkit-line-clamp': `${value}`
      }
    };
  }), {
    '.line-clamp-none': {
      '-webkit-line-clamp': 'unset'
    }
  }], variants('lineClamp'));
}, {
  theme: {
    lineClamp: {
      1: '1',
      2: '2',
      3: '3',
      4: '4',
      5: '5',
      6: '6'
    }
  },
  variants: {
    lineClamp: ['responsive']
  }
});
module.exports = lineClamp;